module.exports = __webpack_public_path__ + "img/软件产品-pow2.29662e2c.png";